import { Bell, Clock, Shield, Truck, X } from "lucide-react";

const TrustForward = () => {
  return (
    <div className="">
      <div className="flex flex-col gap-1">
        <div className="inline-flex items-center gap-2 bg-blue-500/15 border !border-blue-500/30 rounded-full py-2 px-4 mb-6 text-blue-500 text-xs w-fit">
          <Clock size={12} />
          <span>~2 min setup</span>
        </div>

        <h2 className="text-[28px] font-semibold mb-3 text-gray-100">
          Why we ask for your phone
        </h2>

        <p className="text-gray-200 ">
          Your number stays private. Here's exactly how we use it:
        </p>

        <div className="flex flex-col gap-3 py-10">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-[10px] bg-[#274f8b] flex items-center justify-center flex-shrink-0">
              <Bell size={22} color="#60a5fa" />
            </div>
            <p className="text-gray-200 text-sm leading-6">
              Load alerts when lanes match your criteria
            </p>
          </div>
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-[10px] bg-[#274f8b] flex items-center justify-center flex-shrink-0">
              <Shield size={22} color="#60a5fa" />
            </div>
            <p className="text-gray-200 text-sm leading-6">
              Account security & verification
            </p>
          </div>
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-[10px] bg-red-500/15 flex items-center justify-center flex-shrink-0">
              <X size={22} color="#f87171" />
            </div>
            <p className="text-gray-200 text-sm leading-6">
              No robocalls. No selling your data. Ever.
            </p>
          </div>
        </div>

        <div className="h-[1px] bg-[linear-gradient(90deg,transparent,rgba(148,163,184,0.2),transparent)] mb-8" />

        <div className="flex items-center gap-3 bg-blue-500/15 border !border-blue-500/30 rounded-md py-3 px-4 mb-6 text-blue-500 text-xs">
          <div className="p-2 rounded-[10px] bg-[#274f8b] flex items-center justify-center flex-shrink-0">
            <Truck size={22} color="#60a5fa" />
          </div>

          <div>
            <h6 className="text-gray-200 font-medium leading-6 text-lg">
              Truckstop Marketplace Partner
            </h6>
            <p className="text-gray-400 font-light text-xs">
              Verified integration
            </p>
          </div>
        </div>

        <div className="text-center text-gray-500 text-sm">
          <p>Opt out of SMS anytime. No questions asked.</p>
        </div>
      </div>
    </div>
  );
};

export default TrustForward;
